export default __webpack_public_path__ + "static/media/bolt.3670fc62.svg";